import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable, of } from 'rxjs';
import { environment } from '@environments/environment';
import { catchError, switchMap } from 'rxjs/operators';


@Injectable({
    providedIn: 'root'
})


export class QuotationRequestService {
    constructor(private http: HttpClient) { }

    getAll(params) {
        return this.http.get<any>(`${environment.apiUrl}/quotation-requests/`, params);
    }

    getSinglePublicRfq(id, params?) {
        return this.http.get<any>(`${environment.apiUrl}/quotes/public/${id}`, params);
    }

    getPublicRfq(params) {
        return this.http.get<any>(`${environment.apiUrl}/quotes/public`, { params: params });
    }

    checkIfSupplier(requestId, companyId) {
        return this.http.post<any>(`${environment.apiUrl}/quotes/supplierCheck/${requestId}`, { companyId: companyId });

    }

    getAllResponses(params) {
        return this.http.get<any>(`${environment.apiUrl}/quotes/responses`, params);
    }

    getAllRFQ(params) {
        return this.http.get<any>(`${environment.apiUrl}/quotes/`, params);
    }

    getCustomerItems(params) {
        return this.http.get<any>(`${environment.apiUrl}/quotes/customerItems`, params);
    }

    getRequest(id) {
        return this.http.get<any>(`${environment.apiUrl}/quotation-requests/${id}`);
    }

    getSuppliers(params) {
        return this.http.get<any>(`${environment.apiUrl}/quotes/suppliers`, { params: params });
    }

    getRFQ(id, params?) {
        // Try legacy details first, then fallback to public/BOQ details.
        // Also handle cases where the server returns HTTP 200 with body.code != 200.
        return this.http.get<any>(`${environment.apiUrl}/quotes/${id}`, { params: params }).pipe(
            switchMap((res: any) => {
                if (res && res.code === 200) {
                    return of(res);
                }
                // fallback when body indicates error
                return this.http.get<any>(`${environment.apiUrl}/quotes/public/${id}`, { params: params });
            }),
            catchError(() => this.http.get<any>(`${environment.apiUrl}/quotes/public/${id}`, { params: params }))
        );
    }

    getResponse(rfqId) {
        return this.http.get<any>(`${environment.apiUrl}/quotes/response/${rfqId}`);
    }

    request(rfq) {
        return this.http.post<any>(`${environment.apiUrl}/quotes/request`, rfq);
    }
//kkkkk
    singleRequest(rfq) {
        return this.http.post<any>(`${environment.apiUrl}/quotes/single-request`, rfq);
    }

    getUserProjects(params) {
        return this.http.get<any>(`${environment.apiUrl}/quotes/projects`, params);
    }

    updateUserProjects(projectId, params) {
        return this.http.post<any>(`${environment.apiUrl}/quotes/project/update/${projectId}`, params);
    }
    compare(id) {
        return this.http.get<any>(`${environment.apiUrl}/quotes/compare/${id}`);
    }

    addCommunication(id, formData) {
        return this.http.post<any>(`${environment.apiUrl}/quotes/add-communication/${id}`, formData);
    }

    delete(id): Observable<any> {
        return this.http.post<any>(`${environment.apiUrl}/quotes/delete/${id}`, {});
    }

    cancelAll(id): Observable<any> {
        return this.http.post<any>(`${environment.apiUrl}/quotes/cancelAll/${id}`, {});
    }

    cancel(id): Observable<any> {
        return this.http.post<any>(`${environment.apiUrl}/quotes/cancel/${id}`, {});
    }

    accept(id, params): Observable<any> {
        return this.http.post<any>(`${environment.apiUrl}/quotes/accept/${id}`, params);
    }

    reject(id): Observable<any> {
        return this.http.post<any>(`${environment.apiUrl}/quotes/reject/${id}`, {});
    }

    negotiate(id, params): Observable<any> {
        return this.http.post<any>(`${environment.apiUrl}/quotes/negotiating/${id}`,params);
    }

    getUnits(): Observable<any> {
        return this.http.get<any>(`${environment.apiUrl}/units`);
    }


    getQuotationPDFUrl(id) {
        return `${environment.apiUrl}/quotes/quotePDF/${id}`;
    }

    addCustomerItem(params) {
        return this.http.post<any>(`${environment.apiUrl}/quotes/addItem`, params);
    }

    updateCustomerItem(id, params) {
        return this.http.post<any>(`${environment.apiUrl}/quotes/updateItem/${id}`, params);
    }

    removeCustomerItem(id) {
        return this.http.post<any>(`${environment.apiUrl}/quotes/removeItem/${id}`, {});

    }

    getCategoriesByNames(names: string[]): Observable<any[]> {
    return this.http.post<any[]>(`${environment.apiUrl}/quotes/categories/by-names`, { names });
}

    generateComparisonReport(quoteId: string, responseIds?: string[]): Observable<any> {
        return this.http.post<any>(`${environment.apiUrl}/quotes/generate-comparison-report/${quoteId}`, { responseIds });
    }
}
